// extracted by mini-css-extract-plugin
module.exports = {"Footer":"Footer_Footer__exp0f","Link":"Footer_Link__2gVe6","social":"Footer_social__tOq4J"};